import { api } from '../../lib/api';
import type {
  BulkContactCommitResult,
  BulkContactCommitRow,
  BulkContactParseResponse,
  BulkContactRawRow,
} from '../../types/contactBulkImport';

// Bulk Contact Upload — client API. The client extracts raw rows from the
// uploaded file (see bulkImportParse.ts) and posts them as JSON; the server
// owns cleanup / validation / resolution / writes.

export async function parseBulkContacts(
  rows: BulkContactRawRow[],
): Promise<BulkContactParseResponse> {
  return api<BulkContactParseResponse>('/api/contacts/bulk-import/parse', {
    method: 'POST',
    body: JSON.stringify({ rows }),
  });
}

export async function commitBulkContacts(
  rows: BulkContactCommitRow[],
): Promise<BulkContactCommitResult> {
  const res = await api<{ result: BulkContactCommitResult }>(
    '/api/contacts/bulk-import/commit',
    { method: 'POST', body: JSON.stringify({ rows }) },
  );
  return res.result;
}
